import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

function DaySheetIconAction({
  theme,
  styles,
  icon,
  label,
  onPress,
  disabled,
  active,
}) {
  return (
    <TouchableOpacity
      style={[
        styles.daySheetIconBtn,
        active && styles.daySheetIconBtnActive,
        disabled && styles.daySheetIconBtnDisabled,
      ]}
      onPress={onPress}
      disabled={disabled}
      accessibilityLabel={label}
    >
      <Ionicons
        name={icon}
        size={15}
        color={active ? theme.brand.accent : theme.text.secondary}
      />
    </TouchableOpacity>
  );
}

export default function DaySheetToolbar({
  theme,
  styles,
  daySheetMode,
  onModeChange,
  onUploadBanner,
  onUploadBackground,
  onSave,
  daySheetAssetSaving = false,
  daySheetPublicationSaving = false,
  hasUnsavedDaySheetPublication = false,
  daySheetSeededFromDefaults = false,
  daySheetBannerUrl = '',
  daySheetBgUrl = '',
  compact = false,
}) {
  const statusLine = hasUnsavedDaySheetPublication
    ? 'Unsaved changes'
    : daySheetSeededFromDefaults
      ? 'Template — not saved yet'
      : null;

  return (
    <View style={styles.daySheetToolbar}>
      <View style={styles.daySheetToolbarRow}>
        <View style={styles.daySheetModeRow}>
          <TouchableOpacity
            style={[styles.daySheetModeBtn, daySheetMode === 'edit' && styles.daySheetModeBtnActive]}
            onPress={() => onModeChange('edit')}
          >
            <Text style={[styles.daySheetModeBtnText, daySheetMode === 'edit' && styles.daySheetModeBtnTextActive]}>
              Edit
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[styles.daySheetModeBtn, daySheetMode === 'preview' && styles.daySheetModeBtnActive]}
            onPress={() => onModeChange('preview')}
          >
            <Text
              style={[styles.daySheetModeBtnText, daySheetMode === 'preview' && styles.daySheetModeBtnTextActive]}
            >
              Preview
            </Text>
          </TouchableOpacity>
        </View>

        <View style={styles.daySheetToolbarActions}>
          <DaySheetIconAction
            theme={theme}
            styles={styles}
            icon="image-outline"
            label={daySheetBannerUrl ? 'Replace banner image' : 'Upload banner image'}
            onPress={onUploadBanner}
            disabled={daySheetAssetSaving}
            active={Boolean(daySheetBannerUrl)}
          />
          <DaySheetIconAction
            theme={theme}
            styles={styles}
            icon="images-outline"
            label={daySheetBgUrl ? 'Replace background image' : 'Upload background image'}
            onPress={onUploadBackground}
            disabled={daySheetAssetSaving}
            active={Boolean(daySheetBgUrl)}
          />
          <DaySheetIconAction
            theme={theme}
            styles={styles}
            icon={daySheetPublicationSaving ? 'hourglass-outline' : 'save-outline'}
            label={daySheetPublicationSaving ? 'Saving day sheet' : 'Save day sheet'}
            onPress={onSave}
            disabled={!hasUnsavedDaySheetPublication || daySheetPublicationSaving || daySheetAssetSaving}
            active={hasUnsavedDaySheetPublication && !daySheetPublicationSaving}
          />
        </View>
      </View>

      {statusLine ? (
        <Text style={[styles.daySheetToolbarStatus, compact && styles.daySheetToolbarStatusCompact]} numberOfLines={1}>
          {statusLine}
        </Text>
      ) : null}
    </View>
  );
}
